// src/services/supportTicketsApi.js
// Thin wrapper around the support-tickets REST API. Mirrors the conventions
// in feedbackApi.js / authApi.js — uses REACT_APP_API_URL and bearer token.

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Category dropdown source of truth for the frontend. Keep in sync with
// ALLOWED_CATEGORIES in backend-mvp/app/support_tickets/routes.py.
export const TICKET_CATEGORIES = [
    { value: 'single_listing', label: 'Single Listing' },
    { value: 'bulk_listing', label: 'Bulk Listing' },
    { value: 'listing_score', label: 'Listing Score' },
    { value: 'bulk_listing_score', label: 'Bulk Listing Score' },
    { value: 'deal_tag', label: 'Deal Tag' },
    { value: 'marketplace', label: 'Marketplace / Amazon' },
    { value: 'billing', label: 'Billing / Subscription' },
    { value: 'other', label: 'Other' },
];

async function handleResponse(response) {
    let data;
    try {
        data = await response.json();
    } catch {
        data = {};
    }
    if (!response.ok) {
        const err = new Error(data.message || data.error || `HTTP ${response.status}`);
        err.status = response.status;
        err.data = data;
        throw err;
    }
    return data;
}

export const createTicket = async (token, { category, subject, message, attachments }) => {
    if (!token) throw new Error('Authentication required');

    const formData = new FormData();
    formData.append('category', category);
    formData.append('subject', subject);
    formData.append('message', message);
    (attachments || []).forEach(file => formData.append('attachments', file));

    const res = await fetch(`${API_URL}/support-tickets`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData,
    });
    return handleResponse(res);
};

export const listMyTickets = async (token) => {
    if (!token) throw new Error('Authentication required');
    const res = await fetch(`${API_URL}/support-tickets/my`, {
        headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(res);
};

export const getMyTicket = async (token, ticketId) => {
    if (!token) throw new Error('Authentication required');
    const res = await fetch(`${API_URL}/support-tickets/${ticketId}`, {
        headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(res);
};

export const addUserMessage = async (token, ticketId, { message, attachments }) => {
    if (!token) throw new Error('Authentication required');
    const formData = new FormData();
    formData.append('message', message);
    (attachments || []).forEach(file => formData.append('attachments', file));
    const res = await fetch(`${API_URL}/support-tickets/${ticketId}/messages`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData,
    });
    return handleResponse(res);
};
